module.exports = __webpack_public_path__ + "img/product-m-tax.0d31f6b9.png";